var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImpresionsLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x35_6-linkedin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.49867 4.82129H0.185547V15.0346H3.49867V4.82129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.524 4.94107C12.4889 4.93004 12.4555 4.918 12.4186 4.9076C12.374 4.89745 12.3296 4.88897 12.2842 4.88174C12.1084 4.84637 11.9156 4.82132 11.6898 4.82132C9.75834 4.82132 8.53304 6.22995 8.12956 6.77394V4.82129H4.81641V15.0346H8.12953V9.46372C8.12953 9.46372 10.6332 5.96705 11.6897 8.5351V15.0346H15.002V8.14252C15.002 6.59927 13.9472 5.31337 12.524 4.94107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.42649 1.80449C3.42649 2.702 2.70085 3.42935 1.80603 3.42935C0.911158 3.42935 0.185547 2.70197 0.185547 1.80449C0.185547 0.907162 0.911158 0.179688 1.80603 0.179688C2.70085 0.179688 3.42649 0.907162 3.42649 1.80449Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpresionsLinkedin);
export default __webpack_public_path__ + "static/media/impresions_linkedin.7df6fc000717a2c888ad6d71419161c3.svg";
export { ForwardRef as ReactComponent };